import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

export const SectionWrapper = styled.section`
  max-width: 1440px;
  padding: 96px 128px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    padding: 48px 32px;
  }

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 56px 24px;
  }
`

export const SectionTitle = styled.h2<{
  textAlign?: string
  marginTop?: number
  marginRight?: number
  marginBottom?: number
  marginLeft?: number
}>`
  font-family: Inter, sans-serif;
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
  color: ${colors.black};
  text-align: ${props => props.textAlign ?? 'left'};

  margin: 0;
  margin-top: ${props => props.marginTop ?? 0}px;
  margin-right: ${props => props.marginRight ?? 0}px;
  margin-bottom: ${props => props.marginBottom ?? 0}px;
  margin-left: ${props => props.marginLeft ?? 0}px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 32px;
    line-height: 40px;
  }
`
